import { render } from "./NavigationSidebar.vue?vue&type=template&id=8545674e&ts=true"
import script from "./NavigationSidebar.vue?vue&type=script&lang=ts"
export * from "./NavigationSidebar.vue?vue&type=script&lang=ts"

import "./NavigationSidebar.vue?vue&type=style&index=0&id=8545674e&lang=css"

import exportComponent from "/home/brix/jenkins/workspace/Projects/Afashub/Build/prod/afashub.traffix.io_-_qv4352ja/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__